import { createFileRoute } from '@tanstack/react-router'
import { CounterInterface } from '@/components/counter/CounterInterface'

function CounterRoutePage() {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden bg-background">
      <CounterInterface />
    </div>
  )
}

export const Route = createFileRoute('/admin/counter')({
  // Optional deep-link from the server floor's "Settle" action: preselect a
  // table so the Counter loads its open dine-in order and opens checkout.
  //
  // openTableId (F-RSV-N1): the Reservations page just seated a guest and
  // opened their table's tab — load that tab into the ticket (no checkout).
  validateSearch: (search: Record<string, unknown>): { tableId?: string; openTableId?: string } => {
    const out: { tableId?: string; openTableId?: string } = {}
    if (typeof search.tableId === 'string' && search.tableId) out.tableId = search.tableId
    if (typeof search.openTableId === 'string' && search.openTableId) out.openTableId = search.openTableId
    return out
  },
  component: CounterRoutePage,
})
